<template lang="pug">
.form-order.center
  .section-title(@click="show.data = !show.data")
    h3.capitalize Datos Generales

  transition(name="slide-fade")
    .section-container(v-if="show.data")
      form(@submit.prevent="" autocomplete="off")
        .form-section
          .input-container
            input.input(v-model="dataForm.dni" type="number" autocomplete="ño")
            label.label(:class="{ show: dataForm.dni }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="dni" title="Número de Documento")
          .input-container
            input.input(v-model="dataForm.name" autocomplete="ño" required)
            label.label(:class="{ show: dataForm.name }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="name" title="Nombre")

        .form-section
          shInputList(:dataForm="dataForm" :dataOriginal="dataOriginal" title="teléfono" property="phones" pattern="[0-9]{10}" :required="1")

        .form-section
          .input-container
            input.input(v-model="dataForm.email" type="email" autocomplete="ño" required)
            label.label(:class="{ show: dataForm.email }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="email" title="email")

          .input-container
            input.input(v-model="dataForm.location" autocomplete="ño" required)
            label.label(:class="{ show: dataForm.location }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="location" title="Ciudad o Municipio")

          .input-container
            input.input(v-model="dataForm.department" autocomplete="ño" required)
            label.label(:class="{ show: dataForm.department }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="department" title="Departamento")

          .input-container
            label.label(:class="{ show: dataForm.address }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="address" title="Dirección")
            textarea.input(v-model="dataForm.address" autocomplete="ño" rows="5" required)

          .input-container.arrow
            label.label(:class="{ show: dataForm.userPayConveyor !== undefined }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="userPayConveyor" title="Pago de la Transportadora")
            select.select(v-model="dataForm.userPayConveyor" autocomplete="ño")
              option(:value="true" selected) Al Cobro
              option(:value="false") Zimple Paga

          .input-container.arrow
            label.label(:class="{ show: dataForm.cod !== undefined }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="cod" title="Contra Entrega")
            select.select(v-model="dataForm.cod" autocomplete="ño")
              option(:value="false" selected) No
              option(:value="true") Sí

        // .form-section
          .input-container
            select.select(v-model="dataForm.conveyor" autocomplete="ño" required)
              option(v-for="conveyor in conveyors" :value="conveyor") {{ capitalize(conveyor) }}
            label.label(:class="{ show: dataForm.conveyor }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conveyor" title="Transportadora")
          .input-container
            input.input(v-model.number="dataForm.conveyorCost" autocomplete="ño" required)
            label.label(:class="{ show: dataForm.conveyorCost >= 0 }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conveyorCost" title="Costo de la Tranportadora")

        shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .section-title(@click="show.products = !show.products")
    h3.capitalize Productos ({{quantity}}) {{ money(total) }}

  transition(name="slide-fade")
    .section-container(v-if="show.products")
      h3.capitalize {{ text.subtitles.total }} ({{quantity}}) {{ money(total) }}
      .products-order-container
        shProduct(v-for="product in dataForm.cart" :key="product.product" :order="dataForm" :quantity="quantity" :product="product" @updateProduct="updateProduct" @pick="pickProduct" @unpick="unpickProduct" :subtract="dataForm.status === 'created' || dataForm.status === 'approved'" :pick="dataForm.status === 'paid'")

      .products-order-container
        shProduct(v-for="(product, index) in addProducts" :key="product.product" :order="dataForm" :quantity="quantity" :product="product" :add="true" @updateProduct="updateProduct")

      div(v-if="dataForm.status === 'created' || dataForm.status === 'approved'")
        .input-container
          input.input(v-model="product" @keypress.enter.prevent="addProduct" autocomplete="ño")
          label.label(:class="{ show: product }") Escribe la referencia
        shActionButton(:action="addProduct" text="Buscar Producto" textRunning="Buscando Producto")

  .section-title(@click="show.delivery = !show.delivery")
    h3
      span.capitalize Entregas {{ dataOriginal.deliveries && dataOriginal.deliveries.length ? `(${dataOriginal.deliveries.length})` : '(0)' }}

  transition(name="slide-fade")
    .section-container(v-if="show.delivery")
      .list-items.dark.capitalize(v-if="dataOriginal.deliveries ? dataOriginal.deliveries.length : false")
        .item-delivery Id
        .item-delivery Estado
        .item-delivery Transportadora
        .item-delivery Guía
        .item-delivery Fecha Creación
        shExpandButton.hidden(:expand="show.delivery")

      shDelivery(v-for="(delivery, index) in dataOriginal.deliveries" :delivery="delivery" :text="text" :conveyors="conveyors" :key="delivery.delivery")

  .section-title(@click="show.history = !show.history")
    h3.capitalize Historial

  transition(name="slide-fade")
    .section-container(v-if="show.history")
      .list-items.dark.capitalize
        .item-history Estado
        .item-history Actualizado Por
        .item-history Fecha

      .list-items(v-if="dataOriginal.declinedBy")
        .item-history.capitalize {{ text.tables.declined }}
        .item-history
          shNameUser(:dni="dataOriginal.declinedBy")
        .item-history {{ dateTime(dataOriginal.declinedAt) }}

      .list-items(v-if="dataOriginal.approvedBy")
        .item-history.capitalize {{ text.tables.approved }}
        .item-history
          shNameUser(:dni="dataOriginal.approvedBy")
        .item-history {{ dateTime(dataOriginal.approvedAt) }}

      .list-items(v-if="dataOriginal.paidBy")
        .item-history.capitalize {{ text.tables.paid }}
        .item-history
          shNameUser(:dni="dataOriginal.paidBy")
        .item-history {{ dateTime(dataOriginal.paidAt) }}

      .list-items(v-if="dataOriginal.packedBy")
        .item-history.capitalize {{ text.tables.packed }}
        .item-history
          shNameUser(:dni="dataOriginal.packedBy")
        .item-history {{ dateTime(dataOriginal.packedAt) }}

      .list-items(v-if="dataOriginal.sentBy")
        .item-history.capitalize {{ text.tables.sent }}
        .item-history
          shNameUser(:dni="dataOriginal.sentBy")
        .item-history {{ dateTime(dataOriginal.sentAt) }}
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gql from '@my/graphql'
import gqlOrder from '@/graphql/order'
import gqlProduct from '@/graphql/product'
import gqlRefund from '@/graphql/refund'
import gqlInvoice from '@/graphql/invoice'
import shInputList from '@/components/elements/InputList'
import shInputListNumber from '@/components/elements/InputListNumber'
import shSelectList from '@/components/elements/SelectList'
import shInputImageList from '@/components/elements/InputImageList'
import shInputImage from '@/components/elements/InputImage'
import shProduct from '@/components/ecommerce/Product'
import shNameUser from '@/components/elements/NameUser'
import shExpandButton from '@/components/elements/ExpandButton'
import modals from '@my/store/modals'
import shDelivery from './Delivery.vue'
import shRefund from './Refund.vue'

export default {
  name: 'FormOrder',

  mixins: [mForm, mFilters, mDB],

  components: { shSelectList, shInputImageList, shInputImage, shInputList, shInputListNumber, shProduct, shNameUser, shExpandButton, shDelivery, shRefund },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        order: '',
        status: '',
        name: '',
        phones: [],
        address: '',
        location: '',
        department: '',
        methodPay: '',
        methodPayCost: 0,
        deliveryCost: [],
        conveyor: '',
        conveyorCost: 0,
        codeName: '',
        codeType: '',
        codePercent: 0,
        codeValue: 0,
        tip: 0,
        deliveryTime: '',
        isWholesaler: false,
        isDropshipping: false,
        deliveryMan: '',
        deliveryTracking: [],
        mpCode: '',
        cart: [],
        declinedBy: '',
        declinedAt: '',
        approvedBy: '',
        approvedAt: '',
        paidBy: '',
        paidAt: '',
        sentBy: '',
        sentAt: '',
        observations: []
      },
      resolver: 'order',
      key: 'order',
      gql: gqlOrder,
      deliverySchedule: [{ value: '8-21', option: '🌞 8:00 a.m. - 🌚 9:00 p.m.' }, { value: '8-20', option: '🌞 8:00 a.m. - 🌛 8:00 p.m.' }, { value: '8-13', option: '🌞 8:00 a.m. - 😎 1:00 p.m.' }, { value: '13-20', option: '😎 1:00 p.m. - 🌛 8:00 p.m.' }, { value: '13-21', option: '😎 1:00 p.m. - 🌚 9:00 p.m.' }],
      addProducts: {},
      product: '',
      delete: ['order', 'cart', 'createdAt', 'updatedAt', 'declinedAt', 'declinedBy', 'approvedAt', 'approvedBy', 'paidAt', 'paidBy', 'sentAt', 'sentBy', 'packedAt', 'packedBy', 'deliveryTracking', 'payManual', 'observations', 'collectedAt', 'collectedBy', 'collectedValue', 'payU', 'deliveries', 'refund', 'recoveredAt'],
      manualPay: {
        methodPay: '',
        value: ''
      },
      pack: {
        code: '',
        currentTier: '',
        sounds: {
          beepError: 'beep_error.mp3',
          beep: 'beep.mp3',
          error: 'error.mp3',
          tier: 'tier.mp3',
          product: 'product.mp3'
        }
      },
      observation: {
        observation: '',
        type: ''
      },
      show: {
        observations: false,
        products: false,
        data: false,
        pay: false,
        history: false,
        delivery: false,
        refund: false,
        invoice: false
      },
      refund: {
        accountOwnerDni: '',
        accountOwnerDniType: '',
        accountOwnerName: '',
        type: '',
        types: [
          { key: '0', value: 'Derecho al rectracto (aplica hasta 5 días después de que le llegó el producto)' },
          { key: '1', value: 'El pedido llegó tarde' },
          { key: '2', value: 'El pedido no llegó' },
          { key: '3', value: 'No le gustó los productos' },
          { key: '4', value: 'No le quedaron los productos' },
          { key: '5', value: 'Producto fuera de stock' },
          { key: '6', value: 'Envió dinero de más' },
          { key: '7', value: 'Devolución de propina' },
          { key: '6', value: 'El producto llegó dañado o defectuoso' }
        ],
        value: '',
        observation: '',
        method: '',
        account: '',
        accountType: ''
      },
      personType: 'natural',
      documentType: 'cc',
      sendEmail: false,
      statesSpanish: {
        approved: 'aprobada',
        declined: 'rechazada',
        pending: 'pendiente',
        failed: 'fallida',
        reversed: 'reversada',
        retained: 'retenido',
        inited: 'iniciada',
        expired: 'caducada',
        abandoned: 'abandonada',
        cancelled: 'cancelada'
      }
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    updateProduct ({ product, quantity, index }) {
      if (this.addProducts[product]) {
        const quantityAvailable = this.addProducts[product].quantityAvailable
        this.$set(quantityAvailable, index, quantityAvailable[index] - quantity)
      }
    },

    sendForm () {
      if (!this.fillData) {
        this.newOrder()
      } else {
        this.updateOrder()
      }
    },

    newOrder () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateOrder () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteOrder () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    async addProduct () {
      const query = gqlProduct.GET_BY_PRODUCT
      const product = this.product.toLowerCase().trim()

      if (!product) return

      const response = await gql.query(query, { product }, false)

      if (!response) return
      if (!response.data || !response.data.getByProduct) return

      const productFind = response.data.getByProduct
      if (productFind) this.$set(this.addProducts, productFind.product, productFind)

      this.product = ''
    },

    async addPayManual () {
      const query = gqlOrder.ADD_PAY_MANUAL
      const order = this.dataForm.order

      const response = await gql.mutate(query, { order, value: this.manualPay.value, methodPay: this.manualPay.methodPay })

      if (response) modals.showMessage({ message: 'Se agregó el pago correctamente' })
    },

    async approvePayManual (payIndex) {
      const query = gqlOrder.APPROVE_PAY_MANUAL
      const order = this.dataForm.order

      const response = await gql.mutate(query, { order, payIndex })

      if (response) modals.showMessage({ message: 'Se agregó el pago correctamente' })
    },

    async declinePayManual (payIndex) {
      const query = gqlOrder.DECLINE_PAY_MANUAL
      const order = this.dataForm.order

      const response = await gql.mutate(query, { order, payIndex })

      if (response) modals.showMessage({ message: 'Se declinó el pago correctamente' })
    },

    async checkStatePayU (payIndex, platform) {
      const query = gqlOrder.CHECK_STATE_PAY_U
      const order = this.dataForm.order

      const response = await gql.mutate(query, { order, payIndex, platform })

      if (response) modals.showMessage({ message: 'Estado actualizado' })
    },

    async pickProduct (pick) {
      const { product, tier, size } = pick
      const mutation = gqlOrder.PICK_PRODUCT_ORDER
      const order = this.dataForm.order

      const response = await gql.mutate(mutation, { order, product, tier, size })

      if (response) modals.showMessage({ message: `Se alistó el producto ${product} en talla ${size} en el nivel ${tier} de la orden ${order} correctamente` })
    },

    async unpickProduct (pick) {
      const { product, tier, size } = pick
      const mutation = gqlOrder.UNPICK_PRODUCT_ORDER
      const order = this.dataForm.order

      const response = await gql.mutate(mutation, { order, product, tier, size })

      if (response) modals.showMessage({ message: `Se desalistó el producto ${product} en talla ${size} en el nivel ${tier} de la orden ${order} correctamente` })
    },

    async addObservation () {
      const mutation = gqlOrder.ADD_OBSERVATION
      const order = this.dataForm.order

      const response = await gql.mutate(mutation, { order, observation: this.observation.observation, type: this.observation.type })

      if (response) {
        modals.showMessage({ message: `Observación agregada correctamente` })
        this.observation.observation = ''
        this.observation.type = ''
      }
    },
    async newDelivery (order, type) {
      const mutation = gqlOrder.NEW_DELIVERY

      if (!order) return

      const response = await gql.mutate(mutation, { order, type })

      if (response) modals.showMessage({ message: `Se agregó una nueva entrega para la orden ${order}` })
    },

    async newRefund () {
      const mutation = gqlRefund.NEW
      const order = this.dataOriginal.order
      const { type, observation, value, method, account, accountType, accountOwnerDni, accountOwnerDniType, accountOwnerName } = this.refund
      const response = await gql.mutate(mutation, { order, type, value, method, observation, account, accountType, accountOwnerDni, accountOwnerDniType, accountOwnerName })

      if (response) {
        modals.showMessage({ message: `Se creó un nuevo reembolso para la orden ${order}` })
        const refund = this.refund
        refund.type = ''
        refund.value = ''
        refund.observation = ''
        refund.method = ''
        refund.account = ''
        refund.accountType = ''
        refund.accountOwnerName = ''
        refund.accountOwnerDni = ''
        refund.accountOwnerDniType = ''
      }
    },

    async createInvoice () {
      const mutation = gqlInvoice.CREATE
      const order = this.dataOriginal.order
      const response = await gql.mutate(mutation, { order, personType: this.personType, documentType: this.documentType, sendEmail: this.sendEmail })

      if (response && response.data && response.data.createInvoice) {
        modals.showMessage({ message: `Se creó una nueva factura para la orden ${order}` })
      }
    }
  },

  computed: {
    total () {
      return this.dataForm.total || 0
    },

    discount () {
      return this.dataForm.totalDiscount || 0
    },

    quantity () {
      return this.dataForm.quantity || 0
    },

    conveyors () {
      return this.$store.state.variables.conveyors
    },

    methods () {
      return [...this.$store.state.variables.methods, 'cash']
    },

    totalPayManual () {
      if (!this.dataForm.payManual || !this.dataForm.payManual.length) return 0
      return this.dataForm.payManual.reduce((total, pay) => {
        if (pay.state === 'approved') total += pay.value
        return total
      }, 0)
    },

    totalPayU () {
      if (!this.dataForm.payU || !this.dataForm.payU.length) return 0
      return this.dataForm.payU.reduce((total, pay) => {
        if (pay.state === 'approved') total += pay.value
        return total
      }, 0)
    },

    text () {
      return this.$store.state.languages.language().order
    },

    quantitySale () {
      return 3
    }
  },

  watch: {
    dataOriginal: {
      handler () {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-order
  position relative

.preview-text
  margin 1em 0

.products-order-container
  display inline-flex
  justify-content center
  flex-wrap wrap
  gap 3em 1em
  margin 2em 0

.clone-link
  font-size 1.2em

.payU-pays, .manual-pays
  display flex
  justify-content space-between
  align-items center

.buttons-pay-manual
  display inline-flex
  margin .5em 0
  gap 1em

.observation
  display flex
  justify-content space-between

.observation-observation
  flex-basis 40%
  text-align left

.observation-type
  flex-basis 20%

.observation-created-at
  flex-basis 20%

.observation-created-by
  flex-basis 20%
  text-align right

.section-title
  display inline-flex
  justify-content space-between
  cursor pointer
  align-items center
  gap 1em
  text-align center
  width 100%
  padding 0 1em

.method-pay-image
  height 1.5em

.platform-pay-image
  height 1.3em

.platform-pay-image.epayco
  height 1em

.item-pay-manual
  flex-basis 14.2%

.item-pay-u
  flex-basis 14.2%

.pay-u-container
  margin-bottom 2em

.item-history
  flex-basis 33.333%

.item-delivery
  flex-basis 18%

.item-refund
  flex-basis 15%

.pay-u-container, .pay-manual
  overflow-x scroll
  overflow-y none
</style>



// WEBPACK FOOTER //
// src/components/pages/orderDropshipping/Form.vue